export const DROPDOWN_OFFSET_CONFIG = { crossAxis: 20, mainAxis: -20 }
